<!--
  Generated template for the TextBuildingServicesPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header>
	<ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title>
        <!-- <div style="padding-top:15px;padding-bottom:15px;"> -->
          {{ 'SETTINGS_TERMS_BTN' | translate}}
		<!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content padding>
	<!-- <h2>Terms and conditions</h2> -->

	<p>
		<b>Geltung dieser allgemeinen
			Geschäftsbedingungen</b> <br /> Die (IT)&#x000B2; interactive GmbH
		(im folgenden (IT)&#x000B2; interactive GmbH genannt) stellt Ihnen die angebotenen Services auf der
		Grundlage der nachfolgenden Allgemeinen Geschäftsbedingungen zur
		Verfügung. Wenn Sie die (IT)&#x000B2; interactive GmbH angebotenen Services
		nutzen, erkennen Sie die Geltung dieser AGB an. Wenn Sie nicht an
		diese AGB gebunden sein möchten, dürfen Sie die Services von
		(IT)&#x000B2; interactive GmbH nicht nutzen.
	</p>

	<p>
		<b>Leistungen und Nutzungsrechte</b> <br />
		(IT)&#x000B2; interactive GmbH gewährt den Nutzern über das (IT)&#x000B2; interactive GmbH
		Netzwerk derzeit Zugang zu einer Vielzahl von Online
		Services. Die Nutzung dieser Services ist grundsätzlich nur
		volljährigen Personen gestattet. Minderjährige Personen dürfen die
		Dienste nur mit entsprechender Einwilligung ihres gesetzlichen
		Vertreters in Anspruch nehmen. Mit Verwendung der Dienste erklärt
		der Nutzer, dass diese Voraussetzungen erfüllt sind. Um die
		Services zu nutzen, müssen Sie sich einen Zugang zum Internet
		inklusive aller hierzu benötigten technischen Vorrichtungen,
		beispielsweise einen Computer mit Modem oder sonstige technische
		Geräte beschaffen und die hierfür anfallenden Gebühren tragen.
	</p>

	<p>
		<b>Urheber- und weitere Schutzrechte</b> <br />
		Die Inhalte der Services sind mit Ausnahme solcher Inhalte, die von
		Nutzern erstellt wurden, für (IT)&#x000B2; interactive GmbH oder ihre
		Partner urheberrechtlich. Der Gebrauch unterliegt dem geltenden
		Urheberrecht und ist ausschließlich im Rahmen der vorstehend
		eingeräumten Nutzungsrechte zulässig. Die Bezeichnung (IT)&#x000B2; interactive GmbH ist als deutsche,
		Gemeinschafts- und IR-Marke für
		diverse Waren und Dienstleistungen geschützt. Auf die damit
		verbundenen Schutzrechte wird ausdrücklich hingewiesen.
	</p>

	<p>
		<b>Pflichten bei der Registrierung</b> <br />
		Bei der Registrierung erklärt sich der Nutzer bereit,
		wahrheitsgemäße, genaue, aktuelle und vollständige Angaben zu
		seiner Person nach der Vorgabe des Anmeldeformulars zu machen, und
		diese Registrierungsdaten gegebenenfalls zu aktualisieren, damit
		sie wahrheitsgemäß, genau, aktuell und vollständig bleiben. Falls
		eine der Angaben, die Sie machen, unwahr, ungenau, überholt oder
		unvollständig sein sollte oder falls für (IT)&#x000B2; interactive GmbH
		Veranlassung bestehen sollte anzunehmen, dass solche Informationen
		unwahr, ungenau, überholt oder unvollständig sind, ist (IT)&#x000B2; interactive GmbH berechtigt, das
		Nutzerkonto zu löschen und den Nutzer
		von jeglicher Nutzung einzelner oder sämtlicher Services
		auszuschließen. Der Nutzer der im Auftrag eines Unternehmens oder
		einer anderer Körperschaft auf die angebotenen Services zugreift
		oder sie verwendet, bestätigt, dass er insoweit befugt ist, das von
		ihm vertretene Unternehmen oder die entsprechende Körperschaft zu
		diesen Nutzungsbestimmungen zu verpflichten und dass diese für das
		Unternehmen oder die Körperschaft bindend sind. Soweit eine
		entsprechende Legitimation nicht besteht, darf eine Registrierung
		nicht erfolgen.
	</p>

	<p>
		<b>Datenschutz</b> <br /> In der modernen
		Welt von heute eröffnen sich gerade durch das Internet zahlreiche
		neue und faszinierende Möglichkeiten. So kann man aus dem Internet
		zu allen erdenklichen Themen umfassende Informationen beziehen,
		eMails versenden, Produkte erwerben oder Bankgeschäfte tätigen.
		Diese Services erleichtern unser Leben enorm. Bei vielen Vorgängen
		werden allerdings persönlich Daten abgefragt, um den Service zu
		ermöglichen.  Als Anbieter von Internet Servives und im Bewußtsein
		der hieraus entstehenden Gefahren für den Datenschutz, nimmt
		(IT)&#x000B2; interactive GmbH den Schutz der persönlichen Daten des Nutzers
		sehr ernst, die datenschutzrechtlichen Bestimmungen einzuhalten ist
		für uns selbst verständlich. Im folgenden möchten wir darlegen,
		welche der persönlichen Daten des Nutzers bei (IT)&#x000B2; interactive GmbH
		erhoben werden, für welche Zwecke dies erforderlich ist und wie
		sensibel (IT)&#x000B2; interactive GmbH mit Nutzerdaten umgeht.  <br />1.
		(IT)&#x000B2; interactive GmbH bemüht sich, dem Nutzer die meisten Dienste
		zur anonymen Benutzung zur Verfügung zu stellen. <br /> 2.
		Persönliche Nutzerdaten werden nur im Rahmen einer des Nutzers
		erteilten Einwilligung verwendet, es besteht aber jederzeit die
		Möglichkeit eine erteilte Einwilligung zu widerrufen. <br /> 3.
		Ohne das ausdrückliches Einverständnis des Nutzers gibt (IT)&#x000B2; interactive GmbH keine persönlichen Daten
		weiter, ausser wenn (IT)&#x000B2; interactive GmbH zur Herausgabe gesetzlich verpflichtet ist.  Sie können
		uns jederzeit Fragen und Belange zum Datenschutz mitteilen, so dass
		wir darauf reagieren können. Wir entwickeln die technischen
		Möglichkeiten ständig weiter, die Ihnen die Kontrolle Ihrer Daten
		ermöglichen und die Ihre Daten schützen sollen. Besuchen Sie diese
		Seite bitte regelmäßig, um sich über neue Features im Datenschutz
		zu informieren.
	</p>
	<p>
		<b>Account und Passwort</b> <br /> Nach der
		Registrierung erhalten Sie ein Passwort und eine Bezeichnung für
		Ihren Account zugeteilt. Sie müssen sicherstellen, dass Passwort
		und Account keinem Dritten insbesondere nicht an Minderjährige
		zugänglich gemacht werden und tragen für alle Handlungen, die unter
		Verwendung Ihres Passwortes oder Ihres Accounts vorgenommen werden,
		die volle Verantwortung. Sie sind verpflichtet, (IT)&#x000B2; interactive GmbH unverzüglich über jede
		missbräuchliche Benutzung Ihres
		Passwortes oder Accounts sowie über jegliche sonstige Verletzung
		von Sicherheitsvorschriften zu unterrichten. Sie müssen auch
		sicherstellen, dass Sie nach jeder Nutzung Ihren Account verlassen.
		(IT)&#x000B2; interactive GmbH schließt für Verluste oder Schäden, die sich
		aus der Nichterfüllung der Verpflichtungen in diesem Abschnitt
		ergeben, jegliche Haftung aus.
	</p>

	<p>
		<b>Pflichten und Verantwortlichkeiten
			der Nutzer</b> <br /> Die Verantwortung für sämtliche Informationen,
		Daten, Texte, Software, Musik, Fotos, Videos,oder sonstiger
		multimedialer Materialien (im folgenden Inhalt genannt), die
		veröffentlicht oder privat übermittelt werden, liegt ausschließlich
		bei der Person, von der Inhalt stammt. Das bedeutet, dass der
		Nutzer und nicht (IT)&#x000B2; interactive GmbH, die gesamte Verantwortung
		für jeglichen Inhalt tragen, den der Nutzer veröffentlicht, per
		E-Mail versendet oder auf andere Art und Weise über einen (IT)&#x000B2; interactive GmbH Service weiterleitet.
		(IT)&#x000B2; interactive GmbH
		kontrolliert keine Nutzerinhalte übernimmt keine Garantie für die
		Richtigkeit, Angemessenheit und Qualität solcher Inhalte. (IT)&#x000B2; interactive GmbH haftet unter keinen
		Umständen für Inhalte, insbesondere
		nicht für irgendwelche Fehler oder unvollständigen Daten im
		Zusammenhang mit Inhalten und auch nicht für Verluste oder Schäden,
		die durch die Benutzung eines Inhalts entstehen, der
		veröffentlicht, per E-Mail versandt oder anderweitig im Rahmen der
		(IT)&#x000B2; interactive GmbH Services übertragen wurde. Es ist nicht
		gestattet Daten, Texte, Bilder, Dateien, Links, Software oder
		sonstige Inhalte zu veröffentlichen, die rechtswidrig, schädigend,
		bedrohend, missbräuchlich, belästigend, verleumderisch, vulgär,
		obszön, hasserregend, rassistisch oder in sonstiger Weise zu
		beanstanden sind oder Minderjährigen in irgendeiner Weise Schaden
		zufügen; Der Nutzer ist ausschließlich verantwortlich während der
		Benutzung der Services für die Geheimhaltung seines Passwortes und
		der Zugriffsmöglichkeiten auf seinen Computer oder seinem
		Mobiltelefon. Der Nutzer übernimmt insoweit die volle Verantwortung
		für die Benutzung seines Computers oder seines Mobiltelefons.
		(IT)&#x000B2; interactive GmbH bemüht sich mögliche Sicherheitsmaßnahmen zu
		treffen, um das Konto eines Nutzers vor unberechtigtem Zugriff zu
		schützen. (IT)&#x000B2; interactive GmbH kann allerdings nicht versprechen,
		dass die Sicherheitsmaßnahmen "Hacker" abhalten, auf die Services
		und die hinterlegten Inhalte zuzugreifen. Der Nutzer ist damit
		einverstanden, dass er über jeglichen Sicherheitsverstoß informiert
		wird und alle Risiken, von ubefugtem Zugang zu den hinterlegten
		Daten akzeptiert. Soweit sich der Nutzer über ein
		Drittanbieternetzwerk wie z.B. Facebook ein Konto registriert oder
		sich dort anmeldet autorisiert der Nutzer hiermit (IT)&#x000B2; interactive GmbH die Registrierung und alle
		relevanten
		Informationsfelder des Kontos vorab auszufüllen und / oder diese
		Drittanbieteranmeldeinformation zu verwenden, um das Konto
		einzurichten. Wenn sich der Nutzer mit einem Drittanbieternetzwerk
		verbindet, erklärt er sich damit einverstanden die
		Geschäftsbedingungen und Richtlinien dieses Drittanbieters zu
		befolgen. Die Dienste von (IT)&#x000B2; interactive GmbH sind nur für
		private Zwecke bestimmt.

	</p>

	<p>
		<b>Kommunikation mit Mitgliedern </b> <br />
		Die Services fungieren als Treffpunkt von Mitgliedern auf einem
		virtuellen Informationsdesk. (IT)&#x000B2; interactive GmbH beteiligt sich
		nicht an der Kommunikation zwischen den Nutzern. Daher hat
		(IT)&#x000B2; interactive GmbH keine Kontrolle über die Richtigkeit von
		Beiträgen, die von Nutzern der Services stammen. Es wird keine
		Haftung für die Bestätigung der Identität von Nutzern übernommen.
		Dies gilt auch für die Qualifikation, Hintergründe und Fähigkeiten
		von Nutzern des Services. Damit die Services umgesetzt werden
		können, berechtigt der Nutzer (IT)&#x000B2; interactive GmbH auf seine
		Kontaktdaten zurückzugreifen, damit sich (IT)&#x000B2; interactive GmbH mit
		diesen Nutzern in Verbindung setzen kann. Denn der Nutzer erklärt
		sich bereit, dass er berechtigt ist, (IT)&#x000B2; interactive GmbH die
		Kontaktdaten eines Dritten zu übermitteln oder zur Verfügung zu
		stellen und dass diese unter Berücksichtigung des geltenden
		Datenschutzes durch (IT)&#x000B2; interactive GmbH gespeichert werden
		dürfen.
	</p>


	<p>
		<b>Haftung und Gewährleistung</b> <br />
		(IT)&#x000B2; interactive GmbH übernimmt keine Gewähr für die
		ununterbrochene und/oder vollständige Verfügbarkeit der Services,
		für deren Verwendbarkeit zu einem bestimmten Zweck und für deren
		Fehlerfreiheit. (IT)&#x000B2; interactive GmbH weist darauf hin, dass die
		Services für die sichere und dauerhafte Speicherung von Daten weder
		bestimmt noch geeignet sind. Der Nutzer ist verpflichtet, seine
		Daten in der jeweils aktuellen Form außerhalb der (IT)&#x000B2; interactive GmbH
		Services zu sichern. (IT)&#x000B2; interactive GmbH übernimmt
		keinerlei Haftung für den Verlust solcher Daten.Weiterhin haftet
		(IT)&#x000B2; interactive GmbH ausschließlich für vorsätzlich, grob
		fahrlässig oder durch Verletzung vertragswesentlicher Pflichten
		verursachte Schäden. Die Haftung ist auf den typischerweise
		vorhersehbaren Schaden begrenzt. Jede darüber hinausgehende
		Haftung, auch für Folgeschäden und entgangenen Gewinn, ist
		ausgeschlossen. (IT)&#x000B2; interactive GmbH haftet auch nicht für das
		Verhalten von Nutzern und Schäden die aus Fehlverhalten von Nutzern
		der (IT)&#x000B2; interactive GmbH Services entstehen. (IT)&#x000B2; interactive GmbH
		weist ausdrücklich darauf hin, dass die Services keine medizinische
		Beratung beinhalten. Die bereitgestellten Inhalte einschließlich
		aller Texte, Trainingspläne, Ernährungstipps und andere
		Materialien, seien sie durch (IT)&#x000B2; interactive GmbH oder
		Drittparteien bereitgestellt stellen keine medizinische Beratung
		dar und ersetzen nicht den Rat eines Arztes. Insoweit hat der
		Nutzer immer und ausschließlich einen geeigneten Arzt seines
		Vertrauens zu befragen. Der Nutzer stimmt zu, dass etwaige von den
		Services angeleiteten sportlichen Aktivitäten Risiken von
		Personenschäden bis hin zum Tod sowie Risiken von Sachschäden mit
		sich tragen. Insoweit übernimmt der Nutzer alle Risiken, die in
		Verbindung mit diesen Aktivitäten stehen - auch wenn sie nur
		mittelbar durch die Inanspruchnahme der Services von (IT)&#x000B2; interactive GmbH
		begründet wurden. Der Nutzer stellt (IT)&#x000B2; interactive GmbH von jeglicher
		Haftung hinsichtlich seiner sportlichen Aktivitäten vorsorglich uneingeschränkt frei.
	</p>

	<p>
		<b>Besondere Regelungen für den
			(IT)&#x000B2; interactive GmbH Suchservice</b> <br />Der (IT)&#x000B2; interactive GmbH
		Suchservice ermöglicht die Suche nach Internetangeboten
		mit Hilfe von Suchbegriffen und weiteren Kriterien. Die Ergebnisse
		werden in Form einer Fundmengenliste angezeigt. Die Ergebnisse der
		(IT)&#x000B2; interactive GmbH Suchmaschine dürfen vorbehaltlich einer
		individuellen Vereinbarung nicht über Metasuchmaschinen abgefragt
		werden. Bei den Einträgen der Fundmengenliste handelt es sich um
		Verweise auf im Internet öffentlich zugängliche Webseiten. Diese
		Webseiten werden automatisch indexiert. (IT)&#x000B2; interactive GmbH hat
		auf die Gestaltung dieser Webseiten keinen Einfluss und ist für
		deren Inhalte nicht verantwortlich. Beschwerden gegen Inhalte von
		in der Fundmengenliste aufgeführten Webseiten sind daher in erster
		Linie an deren Anbieter zu richten. Webseiten werden aus dem
		Suchindex entfernt, wenn (IT)&#x000B2; interactive GmbH durch einen
		begründeten Hinweis auf deren Rechtswidrigkeit aufmerksam gemacht
		wird. Zur Begründung ist grundsätzlich die Vorlage eines von einem
		in der Europäischen Union ansässigen Gericht im Rahmen seiner
		Zuständigkeit gefälltes, rechtskräftiges Urteil in einer deutschen
		Übersetzung erforderlich. Das betreffende Suchergebnis ist dabei
		mit URL, Suchbegriff und Position möglichst genau zu bezeichnen.
	</p>

	<p>
		<b>Kündigung</b> <br /> Der Nutzer ist
		damit einverstanden, dass (IT)&#x000B2; interactive GmbH aus wichtigem Grund
		auch ohne vorherige Benachrichtigung das Konto des Nutzers und
		dessen Zugang sofort beenden und sperren kann. Ein berechtigter
		Grund liegt insbesondere dann vor, wenn gegen die
		Vertragsbedingungen verstoßen wird, Anträge von
		Strafverfolgungsbehörden vorliegen, ein Eigenantrag des Nutzers
		vorliegt, eine Unterbrechung oder wesentliche Änderung des
		Betriebes der Services gegeben ist, unerwartete technische oder
		Sicherheitsprobleme auftreten, verlängerte Inaktivitätszeiträume
		von einem Jahr vorliegen. Die Kündigung des Kontos durch den Nutzer
		oder (IT)&#x000B2; interactive GmbH ist mit der Löschung aller
		Informationen, Dateien und Inhalte verbunden, die mit der
		Registrierung und dem Konto verbunden sind.

	</p>

	<p>
		<b>Keine kommerzielle Nutzung der
			Services </b> <br /> Sie dürfen die Services oder Teile davon, ihre
		Benutzung oder den Zugang zu den Services nicht kopieren,
		vervielfältigen, nachahmen, verkaufen, weiterverkaufen oder für
		kommerzielle Zwecke welcher Art auch immer nutzen, soweit es Ihnen
		nicht ausdrücklich von (IT)&#x000B2; interactive GmbH gestattet wurde.

	</p>

	<p>
		<b>Änderungen der Services</b> <br />
		(IT)&#x000B2; interactive GmbH behält sich das Recht vor, jederzeit
		sämtliche oder einzelne Services mit oder ohne Mitteilung an den
		Benutzer vorübergehend oder auf Dauer zu ändern, zu unterbrechen
		oder einzustellen. Sie sind damit einverstanden, dass (IT)&#x000B2; interactive GmbH
		weder Ihnen noch Dritten gegenüber für Änderungen,
		Unterbrechungen oder die Einstellung einzelner oder sämtlicher
		Services haftet.
	</p>

	<p>
		<b>Links</b> <br /> (IT)&#x000B2; interactive GmbH
		oder Nutzer können Links zu anderen Webseiten erstellen. Da
		(IT)&#x000B2; interactive GmbH über keinerlei Kontrollmöglichkeit in Bezug
		auf solche Webseiten verfügt, ist (IT)&#x000B2; interactive GmbH für die
		Verfügbarkeit solcher externen Webseiten oder sonstiger
		multimedialer Dateien nicht verantwortlich oder haftbar, macht sich
		Inhalte, die auf oder über solche Webseiten oder multimedialer
		Dateien zugänglich sind, nicht zu eigen und schließt jegliche
		Haftung oder Gewährleistung in Bezug auf diese aus. (IT)&#x000B2; interactive GmbH
		kann daher auch weder direkt noch indirekt für Schäden
		oder Verluste verantwortlich gemacht werden, die aus oder in
		Zusammenhang mit der Benutzung eines Inhalts oder im Vertrauen auf
		einen solchen Inhalt oder auffbund von Waren oder Dienstleistungen
		entstehen oder entstanden sind, die über solche externen Webseiten
		oder Quellen bezogen wurden.
	</p>

	<p>
		<b>Schutzrechte für (IT)&#x000B2; interactive GmbH Services und Software</b>
		<br /> Sie erkennen an, dass die Services sowie jede erforderliche Software,
		die in Zusammenhang mit den Services eingesetzt wird ("Software"), Gegenstand von
		Schutzrechten ist und vertrauliche Informationen enthält, die durch
		Rechtsvorschriften, insbesondere diejenigen zum Schutz des
		geistigen Eigentums, geschützt sind. Sie erkennen weiterhin an,
		dass Inhalte in der Werbung von Sponsoren und Informationen, die
		Sie durch die Services oder durch Werbeinserenten erhalten, durch
		Urheberrechte, Marken, Patente oder sonstige Schutzrechte oder
		Gesetze geschützt sind. Sofern sich (IT)&#x000B2; interactive GmbH oder die
		betreffenden Werbeinserenten nicht schriftlich damit einverstanden
		erklärt haben, dürfen Sie Werke, die auf den Services oder der
		Software beruhen, weder ganz noch teilweise ändern, vermieten,
		verleasen, verleihen, verkaufen, vertreiben oder
		umgestalten.(IT)&#x000B2; interactive GmbH gewährt dem Nutzer ein
		persönliches, nicht übertragbares und nicht ausschließliches Recht,
		den Objekt-Code der (IT)&#x000B2; interactive GmbH Software auf einem
		einzelnen Computer zu benutzen, sofern Sie keine Software kopieren,
		ändern, zerlegen, keine abgeleiteten Werke davon herstellen und
		auch nicht auf sonstige Weise versuchen, den Quellcode ausfindig zu
		machen, keine Software verkaufen, abtreten, Unterlizenzen
		diesbezüglich vergeben oder irgendwelche Rechte an der Software
		übertragen oder sie mit Rechten belasten und dies auch Dritten
		nicht gestatten. Sie dürfen die Software in keiner Weise verändern
		oder geänderte Versionen der Software benutzen, insbesondere nicht
		zu dem Zweck, sich unberechtigten Zugang zu den Services zu
		verschaffen. Sie dürfen sich auf keinem anderen Weg Zugang zu den
		Services verschaffen, als über die Schnittstelle, die Ihnen von
		(IT)&#x000B2; interactive GmbH bereitgestellt wird.

	</p>

	<p>
		<b>(IT)&#x000B2; interactive GmbH in Deutschland
		</b> <br />Die Services von (IT)&#x000B2; interactive GmbH werden von
		Deutschland aus angeboten. (IT)&#x000B2; interactive GmbH sichert nicht zu,
		dass die Services in anderen Ländern geeignet oder verfügbar sind.
		Der Zugang oder die Nutzung von Services von Ländern und Gebieten
		aus, in denen ein solcher Zugang oder die Verwendung illegal ist,
		ist verboten. Nutzer, die sich dazu entschließen, von einem anderen
		Standort als Deutschland aus auf die Services zuzugreifen, machen
		dies ausschließlich auf eigene Gefahr und unter Einhaltung der
		örtlich geltenden aktuellen Gesetze.

	</p>

	<p>
		<b>Ausschlußfrist</b> <br />Unbeschadet
		etwaiger kürzerer gesetzlicher Fristen, müssen jedwede Ansprüche
		aus oder im Zusammenhang mit der Nutzung des Services oder dieser
		Nutzungsbedingungen innerhalb eines (1) Jahres nach ihrer
		Entstehung gerichtlich geltend gemacht werden oder sie sind für
		immer ausgeschlossen.
	</p>

	<p>
		<b>Schlussbestimmungen</b> <br /> Betreiber
		der (IT)&#x000B2; interactive GmbH Services und Vertragspartner des Nutzers
		ist die (IT)&#x000B2; interactive GmbH , Joseph-von-Fraunhofer Str. 20, 44227 Dortmund, E-Mail:
		info@it2in.de. Weitere Informationen zum Anbieter sind über
		die Anbieterkennzeichnungen (Link "Impressum") abrufbar. Das durch
		diese Nutzungsbedingungen geregelte Nutzungsverhältnis unterliegt
		ausschließlich deutschem Recht unter Ausschluss des Abkommens der
		Vereinten Nationen über den internationalen Warenkauf. Leistungs-
		und Erfüllungsort ist 60594 Frankfurt. Als Gerichtsstand wird, wenn
		der Nutzer Kaufmann, juristische Person des öffentlichen Rechts
		oder öffentlich-rechtliches Sondervermögen ist oder in der
		Bundesrepublik keinen allgemeinen Gerichtsstand hat, ebenfalls
		60594 Frankfurt vereinbart. Sollte eine Bestimmung dieser
		Nutzungsbedingungen unwirksam sein oder werden, lässt dies die
		Wirksamkeit der übrigen Bestimmungen oder abtrennbarer Teile der
		unwirksamen Klausel unberührt. Anstelle der unwirksamen gilt eine
		andere Regelung als vereinbart, die im Rahmen des rechtlich
		Zulässigen dem Zweck der unwirksamen Regelung unter
		Berücksichtigung der Interessen der Beteiligten am nächsten kommt.
		Entsprechendes gilt für Regelungslücken. (IT)&#x000B2; interactive GmbH
		behält sich das Recht vor, diese AGBs für die Zukunft zu ändern
		oder zu ergänzen. Auf etwaige Änderungen oder Ergänzungen dieser
		AGBs werden Sie jeweils gesondert hingewiesen. Die geänderten bzw.
		ergänzten AGBs finden erst Anwendung, wenn Sie die Services von
		(IT)&#x000B2; interactive GmbH nach Erhalt des Hinweises erneut nutzen.
	</p>
</ion-content>